import { EActionCode } from 'affiny-core/modules/api/repositories/payment/paymentActionCodes';
import { goToRateCardActions } from 'affiny-core/redux/actions/goToRatecardActions';
import { Box, Button, Flex, rem, Text } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const CompatibilityReportBreaker = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Flex
      position="sticky"
      bottom={0}
      left={0}
      width="100%"
      flexDirection="column"
      justifyContent="flex-end"
      alignItems="center"
      onClick={() =>
        dispatch(
          goToRateCardActions.goToRateCard({
            actionCode: EActionCode.CTA_COMPAT_REPORT,
          })
        )
      }
      cursor="pointer"
    >
      <Box
        height={rem(146)}
        width="100%"
        backgroundImage="linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%)"
      />
      <Flex
        width="100%"
        height={rem(100)}
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="center"
        backgroundColor="light"
        flexGrow={0}
      >
        <Text fontSize={rem(18)} color="caribbeanGreen" fontWeight={600}>
          {t('compatibilityReport.breaker.text')}
        </Text>
        <Box my="medium">
          <Button
            size="small"
            color="subscription"
            variant="contained"
            text={t('compatibilityReport.breaker.cta')}
          />
        </Box>
      </Flex>
    </Flex>
  );
};
